import { Injectable, Inject } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { AccountUser } from "../models/account-user.model";

@Injectable({
    providedIn: 'root'
})
export class AccountUserService {

    constructor(
        @Inject('API_GATEWAY_URL') private readonly apiUrl: string,
        private readonly _http: HttpClient
    ) { }

    findByAccountByUser(accountId: number, userId: string): Observable<AccountUser> {
        return this._http.get<AccountUser>(`${this.apiUrl}/auth/accountsUsers/account/${accountId}/user/${userId}`);
    }

    listByUser(userId: string): Observable<AccountUser[]> {
        return this._http.get<AccountUser[]>(`${this.apiUrl}/auth/accountsUsers/user/${userId}`);
    }

    listByAccountAsync(accountId: number): Observable<AccountUser[]> {
        return this._http.get<AccountUser[]>(`${this.apiUrl}/auth/accountsusers/account/${accountId}`);
    }

    findAsync(id: string): Observable<AccountUser> {
        return this._http.get<AccountUser>(`${this.apiUrl}/auth/accountsusers/${id}`);
    }

    activateAsync(id: string): Observable<boolean> {
        return this._http.patch<boolean>(`${this.apiUrl}/auth/accountsusers/${id}/activate`, {});
    }

    deactivateAsync(id: string): Observable<boolean> {
        return this._http.patch<boolean>(`${this.apiUrl}/auth/accountsusers/${id}/deactivate`, {});
    }

    generateClockInUrl(userId: string): Observable<string> {
        return this._http.patch<string>(`${this.apiUrl}/auth/accountsusers/generateClockInUrl/${userId}`, null, { responseType: <any>'string' });
    }
}